import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'refund-table',
  components: {},
  props: {
    dataSource: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      FeeCalculateTypeMap: {
        0x00: "无",
        0x10: "票款",
        0x11: "实付票款",
        0x20: "每单",
        0x21: "每张票"
      },
      FeeCalculateTypes: {
        NONE: 0x00,
        RADIO: 0x01,
        AMOUNT: 0x02,
        RADIO_TICKET: 0x10,
        RADIO_ACTUAL_TICKET: 0x11,
        AMOUNT_ORDER: 0x20,
        AMOUNT_TICKET: 0x21
      }
    };
  },
  mounted: function mounted() {},
  methods: {
    getRefundRuleName: function getRefundRuleName(feeCalculateType, feeCalculateValue, refundType) {
      var fee = '/';
      if (feeCalculateType === this.FeeCalculateTypes.NONE) {
        fee = "免费退票";
      } else if (feeCalculateType === this.FeeCalculateTypes.RADIO_TICKET || feeCalculateType === this.FeeCalculateTypes.RADIO_ACTUAL_TICKET) {
        fee = "\u6263\u9664".concat(this.FeeCalculateTypeMap[feeCalculateType]).concat(feeCalculateValue || 0, "%");
        if (refundType === 1) {
          // 退款类型为票款时
          fee += " \uFF0C\u4E0D\u9000\u5FEB\u9012\u8D39";
        }
      } else {
        fee = "".concat(this.FeeCalculateTypeMap[feeCalculateType], "\u6263\u9664").concat(feeCalculateValue || 0, "\u5143");
      }
      return fee;
    }
  }
};